import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {UserPermissionManager} from './user-permission';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {CrmSection} from '@enum/crm-section';

class MarketingPermissionClass implements UserPermission {
  readonly userRole = UserRole.MARKETING;
  readonly labelRole = 'Marketing';
  readonly isAuthenticated = true;

  readonly canRequestEto = false;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = false;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = true;
  readonly canHaveManyEditableProforma = false;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = false;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = false;
  readonly crmSectionsVisible = [CrmSection.Lead, CrmSection.VerifiedContact, CrmSection.CustomerList, CrmSection.Claims, CrmSection.Messages];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = [];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [];
  readonly visibleUserAreaColumns = [];

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = true;
  readonly canSeeAssignedUserStats = true;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = false;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = false;
  readonly canDownloadPackingList = false;
  readonly canSeeConfigurationList = false;
  readonly canSeeCustomerConfigurationTab = false;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = false;

  readonly composerAllowed = true;
}

const MarketingPermission = new MarketingPermissionClass();

UserPermissionManager.instance.assignPermissionForRole(MarketingPermission);
